/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Category_Discovery_DescInputs */

const en_directory_detail_category_discovery_desc = /** @type {(inputs: Directory_Detail_Category_Discovery_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published tools that share this product's primary category. They are discovery links, not editorial comparisons.`)
};

const zh_directory_detail_category_discovery_desc = /** @type {(inputs: Directory_Detail_Category_Discovery_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与当前产品共享主要分类的已发布工具。它们用于继续发现，并非编辑对比结论。`)
};

/**
* | output |
* | --- |
* | "Published tools that share this product's primary category. They are discovery links, not editorial comparisons." |
*
* @param {Directory_Detail_Category_Discovery_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_category_discovery_desc = /** @type {((inputs?: Directory_Detail_Category_Discovery_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Category_Discovery_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_category_discovery_desc(inputs)
	return zh_directory_detail_category_discovery_desc(inputs)
});
export { directory_detail_category_discovery_desc as "directory.detail.category_discovery_desc" }